"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OSCTrackersSettingT = exports.OSCTrackersSetting = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class OSCTrackersSetting {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsOSCTrackersSetting(bb, obj) {
        return (obj || new OSCTrackersSetting()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsOSCTrackersSetting(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new OSCTrackersSetting()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    head() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    chest() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    waist() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    knees() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    feet() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    elbows() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    hands() {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startOSCTrackersSetting(builder) {
        builder.startObject(7);
    }
    static addHead(builder, head) {
        builder.addFieldInt8(0, +head, +false);
    }
    static addChest(builder, chest) {
        builder.addFieldInt8(1, +chest, +false);
    }
    static addWaist(builder, waist) {
        builder.addFieldInt8(2, +waist, +false);
    }
    static addKnees(builder, knees) {
        builder.addFieldInt8(3, +knees, +false);
    }
    static addFeet(builder, feet) {
        builder.addFieldInt8(4, +feet, +false);
    }
    static addElbows(builder, elbows) {
        builder.addFieldInt8(5, +elbows, +false);
    }
    static addHands(builder, hands) {
        builder.addFieldInt8(6, +hands, +false);
    }
    static endOSCTrackersSetting(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createOSCTrackersSetting(builder, head, chest, waist, knees, feet, elbows, hands) {
        OSCTrackersSetting.startOSCTrackersSetting(builder);
        OSCTrackersSetting.addHead(builder, head);
        OSCTrackersSetting.addChest(builder, chest);
        OSCTrackersSetting.addWaist(builder, waist);
        OSCTrackersSetting.addKnees(builder, knees);
        OSCTrackersSetting.addFeet(builder, feet);
        OSCTrackersSetting.addElbows(builder, elbows);
        OSCTrackersSetting.addHands(builder, hands);
        return OSCTrackersSetting.endOSCTrackersSetting(builder);
    }
    unpack() {
        return new OSCTrackersSettingT(this.head(), this.chest(), this.waist(), this.knees(), this.feet(), this.elbows(), this.hands());
    }
    unpackTo(_o) {
        _o.head = this.head();
        _o.chest = this.chest();
        _o.waist = this.waist();
        _o.knees = this.knees();
        _o.feet = this.feet();
        _o.elbows = this.elbows();
        _o.hands = this.hands();
    }
}
exports.OSCTrackersSetting = OSCTrackersSetting;
class OSCTrackersSettingT {
    constructor(head = false, chest = false, waist = false, knees = false, feet = false, elbows = false, hands = false) {
        this.head = head;
        this.chest = chest;
        this.waist = waist;
        this.knees = knees;
        this.feet = feet;
        this.elbows = elbows;
        this.hands = hands;
    }
    pack(builder) {
        return OSCTrackersSetting.createOSCTrackersSetting(builder, this.head, this.chest, this.waist, this.knees, this.feet, this.elbows, this.hands);
    }
}
exports.OSCTrackersSettingT = OSCTrackersSettingT;
